import React from "react";
import {Controller, useController} from "react-hook-form";
import Select from "@material-ui/core/Select";
import {
    Box,
    Card,
    CardContent,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel, InputAdornment,
    InputLabel,
    ListItemText,
    MenuItem,
    Paper,
    Switch,
    TextareaAutosize,
    TextField,
    Typography
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {Autocomplete} from "@material-ui/lab";
import Button from "@material-ui/core/Button";
import {styled} from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import {CloseSharp} from "@mui/icons-material";


const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-track': {
        borderRadius: 22 / 2,
        '&:before, &:after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
        },
        '&:before': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
            left: 12,
        },
        '&:after': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M19,13H5V11H19V13Z" /></svg>')`,
            right: 12,
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 16,
        height: 16,
        margin: 2,
    },
}));
export function MUIInput({control, name, rules, defaultValue, value, onInputChange, label, errors, inputPrp, onInputCopy, onInputCut, onInputPaste, type, disabled, iconProperties}) {

    const {field: {onChange, ref, ...inputProps}} = useController({
        name,
        control,
        rules: rules,
        defaultValue: defaultValue,
    });

    let err = (errors && errors[name]) ? errors[name].message : false;
    return (
        <>
            <TextField fullWidth {...inputProps} inputRef={ref} inputProps={inputPrp} disabled={disabled}
                       InputProps={iconProperties}
                       value={value}
                       onCopy={onInputCopy}
                       onCut={onInputCut}
                       onPaste={onInputPaste}
                       type={type}
                       onChange={val => {
                           onChange(val);
                           onInputChange(val)
                       }} label={label} variant="outlined" error={err}/>
            {err && <span className='errorMessage'>{err}</span>}
        </>
    );
}

export function MUISwitch({control, name, rules, defaultValue, value, onChecked, label, errors, inputPrp, disabled}) {
    let err = (errors && errors[name]) ? errors[name].message : false;
    const {field: {onChange, ref, ...inputProps}} = useController({
        name,
        control,
        rules: rules,
        defaultValue: defaultValue,
    });
    return (
        <>
            <Stack direction="row" spacing={1} alignItems="center">
                <InputLabel style={{color:"#000000"}} id={"id-"+name+label}>{label}</InputLabel>
                <Typography>No</Typography>
                <Android12Switch color="primary" {...inputProps} inputRef={ref} checked={value} onChange={val => {onChange(val); onChecked(val);}} inputProps={{ 'aria-label': 'ant design' }} />
                <Typography>Yes</Typography>
            </Stack>
            {err && <span className='errorMessage'>{err}</span>}
        </>
    );
}


export function MUITextareaAutosize({control, name, rules, defaultValue, value, onInputChange, label, errors, minRows, placeholder, style}) {

    const {field: {onChange, ref, ...inputProps}} = useController({
        name,
        control,
        rules: rules,
        defaultValue: defaultValue,
    });

    return (
        <>
            <TextareaAutosize fullWidth {...inputProps} inputRef={ref} value={value} onChange={val => {
                onChange(val);
                onInputChange(val)
            }} label={label} aria-multiline={true} minRows={minRows} placeholder={placeholder} style={style} error={errors[name]}/>
            {errors && errors[name] && <span className='errorMessage'>{errors[name].message}</span>}
        </>
    );
}


export function MUIDatePicker({name, label, dateValue, handleDateChange, errors, control, rules, minDateMessage, maxDateMessage, minDate}) {
    const {field: {onChange, ref, ...inputProps}} = useController({
        name,
        control,
        rules: rules,
        defaultValue: dateValue,
    });

    return (
        <>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker fullWidth error={errors[name]} {...inputProps} minDate={minDate}
                                    minDateMessage={minDateMessage} maxDateMessage={maxDateMessage}
                                    inputVariant="outlined"
                                    id={name}
                                    inputRef={ref}
                                    label={label}
                                    name={name}
                                    format="MM/dd/yyyy"
                                    value={dateValue}
                                    onChange={val => {
                                        onChange(val);
                                        handleDateChange(val)
                                    }}
                                    animateYearScrolling
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                />
            </MuiPickersUtilsProvider>
            {errors && errors[name] && <span className='errorMessage'>{errors[name].message}</span>}
        </>
    );
}

export function MUISelect({
                              name, errors,
                              label,
                              control,
                              defaultValue,
                              disabled,
                              children, rules, value, onFormChange, required,
                              ...props
                          }) {

    const {
        field: {onChange, ref, ...inputProps},
    } = useController({
        name,
        control,
        rules: rules,
        defaultValue: defaultValue,
    });

    return (
        <>
            <FormControl variant="outlined" fullWidth error={errors[name]}>
                <InputLabel id={"id-"+name+label}>{label}</InputLabel>
                <Select labelId={"id-"+name+label} defaultValue={defaultValue} disabled={disabled || false}
                    label={label} {...inputProps} value={value} onChange={val => {
                    onChange(val);
                    onFormChange(val);
                }} name={name} fullWidth inputRef={ref} variant="outlined">
                    {children}
                </Select>
            </FormControl>
            {errors && errors[name] && <span className='errorMessage'>{errors[name].message}</span>}
        </>
    );
}


export function MUIMultiSelect({
                              name, errors,
                              label,
                              control,
                              defaultValue,
                              dropdownValues, rules, value, onFormChange, required,
                              ...props
                          }) {

    const {
        field: {onChange, ref, ...inputProps},
    } = useController({
        name,
        control,
        rules: rules,
        defaultValue: defaultValue,
    });

    return (
        <>
            <FormControl variant="outlined" fullWidth error={errors[name]}>
                <InputLabel id={"id-" + name + label}>{label}</InputLabel>
                <Select labelId={"id-" + name + label} multiple
                        renderValue={(selected) => (
                            <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                                {selected.map((value) => (
                                    <Chip key={value} label={dropdownValues.filter(x => x.value === value)[0].label} size="small"/>
                                ))}
                            </Box>
                        )}
                        label={label} {...inputProps} value={value}
                        onChange={val => {
                            onChange(val);
                            onFormChange(val);
                        }} name={name} fullWidth inputRef={ref} variant="outlined">
                    {dropdownValues.map(k => (
                        <MenuItem key={k.value} value={k.value}>
                            <Checkbox color="primary" checked={value && value.indexOf(k.value) > -1}/>
                            <ListItemText primary={k.label}/>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {errors && errors[name] && <span className='errorMessage'>{errors[name].message}</span>}
        </>
    );
}

export function MUICheckbox({control, name, rules, defaultValue, value, onFieldChange, label, errors}) {
    const {
        field: {onChange, ref, ...inputProps}
    } = useController({
        name,
        control,
        rules: rules,
        defaultValue: defaultValue,
    });


    return (
        <>
            <FormControlLabel
                control={
                    <Checkbox {...inputProps} inputRef={ref}
                              checked={value}
                              onChange={val => {
                                  onChange(val);
                                  onFieldChange(val)
                              }}
                              name={name}
                              color="primary"
                    />
                }
                label={label}
            />
            {errors && errors[name] && <span className='errorMessage'>{errors[name].message}</span>}
        </>
    );
}


export function MUIAutoComplete({control, name, value, onValueChange, label, errors, options, disabled}) {
    let err = (errors && errors[name]) ? errors[name].message : false;
    return (
        <>
            <Controller
                name={name}
                render={({field}) => (
                    <Autocomplete {...field}
                        value={value} disabled={disabled}
                        getOptionLabel={option => option}
                        options={options}
                        onChange={(event, newValue) => {
                            field.onChange(newValue);
                            onValueChange({target: {name: name, value: newValue}});
                        }}
                        renderInput={params => <TextField {...params} label={label} variant="outlined" fullWidth
                                                          error={err}/>}
                    />
                )}
                control={control}
                defaultValue={value ?? options[0]}
            />
            {err && <span className='errorMessage'>{err}</span>}
        </>
    );
}

export function MUIConfirmationDialog({showDialog, handleDialogClose, dialogTitle, dialogContent, handleUserConfirmation}) {
    return (
        <Dialog
            open={showDialog}
            onClose={handleDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {dialogTitle}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {dialogContent}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDialogClose}>No</Button>
                <Button onClick={handleUserConfirmation} autoFocus>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export function MUICardWithControl({children, label, icon}) {
    return (
        <Paper elevation={3}>
            <Card variant="outlined" style={{backgroundColor: "white"}}>
                <CardContent>
                    <Stack direction="row" spacing={1}>{icon}<Typography>{label}</Typography></Stack>
                    {children}
                </CardContent>
            </Card>
        </Paper>
    );
}
